import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtShortDate } from "../../lib/format";
import { iconChipStyle } from "../../lib/icons-resolve";
import { Glyph } from "./Glyph";
import { Button, Caption, DescrBox, DifficultyTag, Lead, List, ListRow, SectionHeader, Sheet } from "./ds";
import "./recovery-info.css";

// v30 — okno, ktoré sa otvorí ťuknutím na lištu Režimu prežitia. Odpovedá na to, čo sa
// človek pýta, keď na lištu ťukne: čo to so mnou robí, čo mi vlastne spí a ako z toho von.
// Zoznam spiacich návykov je tu naschvál celý (nie len tie, čo sú dnes na rade) — inak by
// sa nedalo zistiť, čo režim odložil, a človek by musel veriť číslu.

// slovenské skloňovanie po číslovke: 1 → one, 2–4 → few, inak → many
const sk = (n, one, few, many) => (n === 1 ? one : n >= 2 && n <= 4 ? few : many);

export function RecoveryInfoSheet({ onClose, onChanged }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(null);

  const load = () => api("/api/recovery/status")
    .then(setD)
    .catch(() => setErr("Stav režimu sa nepodarilo načítať."));
  useEffect(() => { load(); }, []);

  const resume = async (t) => {
    setBusy(t.id);
    try {
      await api("/api/recovery/resume", { method: "POST", body: { task_id: t.id } });
      await load();
      onChanged && onChanged();
    } catch (e) {
      setErr((e && e.message) || "Návyk sa nepodarilo vrátiť.");
    }
    setBusy(null);
  };

  const stop = async () => {
    try {
      await api("/api/recovery/stop", { method: "POST", body: {} });
      onChanged && onChanged();
      onClose();
    } catch { setErr("Režim sa nepodarilo ukončiť."); }
  };

  return (
    <Sheet
      icon="heart" title="Režim prežitia" onClose={onClose}
      footer={
        <>
          <Button variant="ghost" block onClick={onClose}>Zavrieť</Button>
          {d && d.active && <Button variant="secondary" block onClick={stop}>Ukončiť režim</Button>}
        </>
      }
    >
      {err && <div className="bz-recinfo__err">{err}</div>}
      {!d && !err && <Caption variant="note">Načítavam…</Caption>}
      {/* režim medzitým vypršal alebo ho ukončilo iné zariadenie — bez tohto by tu ostala
          holá hlavička a pätička „Ukončiť režim" pre niečo, čo už nebeží */}
      {d && !d.active && (
        <Caption variant="note">Režim prežitia už nebeží — návyky sú späť v hre.</Caption>
      )}

      {d && d.active && (
        <>
          <DescrBox className="bz-recinfo__intro" text={
            "Odložené návyky sa dnes nerátajú — ani do splnených, ani do bodov. Séria sa cez ne "
            + "premostí, takže nič nepretrhneš. Výzvy a súťaže bežia ďalej, lebo sú záväzkom voči "
            + "ostatným, ale perfektnému dňu už nebránia."} />

          <div className="bz-recinfo__facts">
            <span><strong>Deň {d.day}</strong> z {d.total}</span>
            <span>Vrátia sa {fmtShortDate(d.recovery_until)}</span>
          </div>

          <SectionHeader label="Spia" count={d.paused.length} />
          {d.paused.length === 0 ? (
            <Caption variant="note">Nič nie je odložené — režim beží naprázdno.</Caption>
          ) : (
            <>
              <Caption variant="note">Ktorýkoľvek môžeš vrátiť späť do hry aj teraz.</Caption>
              <List className="bz-recinfo__list">
                {d.paused.map((t) => (
                  <ListRow
                    key={t.id}
                    lead={<Lead size="sm" tone="outline" style={iconChipStyle(t.icon_color)}><Glyph icon={t.icon} size={17} /></Lead>}
                    title={t.label}
                    meta={<DifficultyTag level={t.difficulty} size="xs" showLabel={false} />}
                    trailing={
                      <Button variant="ghost" size="sm" disabled={busy === t.id}
                        onClick={() => resume(t)}>
                        {busy === t.id ? "…" : "Vrátiť"}
                      </Button>
                    }
                  />
                ))}
              </List>
            </>
          )}

          <p className="bz-recinfo__tail">
            V hre ti {sk(d.kept, "ostal", "ostali", "ostalo")} {d.kept} {sk(d.kept, "návyk", "návyky", "návykov")}
            {d.challenges > 0 && <> a {d.challenges} {sk(d.challenges, "výzva", "výzvy", "výziev")}</>}.
          </p>
        </>
      )}
    </Sheet>
  );
}
